import { WithRef } from '@principle-theorem/shared';
import { ITreatmentStep } from '../../clinical-charting/treatment/treatment-step';
import { ITemplateContext } from '../templating';
import { IPatientTemplateContext } from './patient-context';
import {
  ITreatmentPlanScopeData,
  ITreatmentPlanTemplateContext,
} from './treatment-plan-context';

export interface ITreatmentStepScopeData extends ITreatmentPlanScopeData {
  treatmentStep: WithRef<ITreatmentStep>;
}

export interface ITreatmentStepTemplateContext
  extends ITemplateContext,
    ITreatmentPlanTemplateContext,
    IPatientTemplateContext {
  treatmentStepName: string;
  treatmentStepCreatedAt: string;
  treatmentStepCreatedAtDate: string;
  treatmentStepCreatedAtTime: string;
}
